var map = {
	"./audio/01.mp3": 21072,
	"./audio/02.mp3": 86039,
	"./audio/03.mp3": 51790,
	"./audio/04.mp3": 10292,
	"./audio/05.mp3": 12796,
	"./audio/06.mp3": 29118,
	"./audio/07.mp3": 33158,
	"./audio/08.mp3": 70810,
	"./audio/09.mp3": 6495,
	"./audio/10.mp3": 57037,
	"./cards/backcard.png": 39446,
	"./cards/mayores/el-carro.jpg": 51234,
	"./cards/mayores/el-carro.png": 1714,
	"./cards/mayores/el-colgado.jpg": 95028,
	"./cards/mayores/el-colgado.png": 56684,
	"./cards/mayores/el-diablo.jpg": 54237,
	"./cards/mayores/el-diablo.png": 56833,
	"./cards/mayores/el-emperador.jpg": 37944,
	"./cards/mayores/el-emperador.png": 71635,
	"./cards/mayores/el-ermitanio.jpg": 30092,
	"./cards/mayores/el-hermitaño.png": 10559,
	"./cards/mayores/el-juicio.jpg": 84360,
	"./cards/mayores/el-juicio.png": 76622,
	"./cards/mayores/el-loco.jpg": 54470,
	"./cards/mayores/el-loco.png": 33710,
	"./cards/mayores/el-mago.jpg": 26710,
	"./cards/mayores/el-mago.png": 15260,
	"./cards/mayores/el-mundo.jpg": 64962,
	"./cards/mayores/el-mundo.png": 4201,
	"./cards/mayores/el-papa.jpg": 34900,
	"./cards/mayores/el-papa.png": 99523,
	"./cards/mayores/el-sol.jpg": 12792,
	"./cards/mayores/el-sol.png": 44914,
	"./cards/mayores/la-emperatriz.jpg": 62490,
	"./cards/mayores/la-emperatriz.png": 80916,
	"./cards/mayores/la-estrella.jpg": 48390,
	"./cards/mayores/la-estrella.png": 82617,
	"./cards/mayores/la-fuerza.jpg": 3170,
	"./cards/mayores/la-fuerza.png": 65906,
	"./cards/mayores/la-justicia.jpg": 86877,
	"./cards/mayores/la-justicia.png": 45717,
	"./cards/mayores/la-luna.jpg": 79366,
	"./cards/mayores/la-luna.png": 18680,
	"./cards/mayores/la-muerte.jpg": 12358,
	"./cards/mayores/la-muerte.png": 19974,
	"./cards/mayores/la-rueda-de-la-fortuna.jpg": 50699,
	"./cards/mayores/la-rueda-de-la-fortuna.png": 80715,
	"./cards/mayores/la-sacerdotisa.jpg": 91742,
	"./cards/mayores/la-sacerdotisa.png": 93623,
	"./cards/mayores/la-templanza.jpg": 62085,
	"./cards/mayores/la-templanza.png": 45675,
	"./cards/mayores/la-torre.jpg": 60333,
	"./cards/mayores/la-torre.png": 76048,
	"./cards/mayores/los-enamorados.jpg": 67424,
	"./cards/mayores/los-enamorados.png": 81564,
	"./cards/menores/bastos/as.jpg": 67855,
	"./cards/menores/bastos/caballo.jpg": 7740,
	"./cards/menores/bastos/cinco.jpg": 27970,
	"./cards/menores/bastos/cuatro.jpg": 21118,
	"./cards/menores/bastos/diez.jpg": 37482,
	"./cards/menores/bastos/dos.jpg": 77052,
	"./cards/menores/bastos/nueve.jpg": 34954,
	"./cards/menores/bastos/ocho.jpg": 90416,
	"./cards/menores/bastos/reina.jpg": 62229,
	"./cards/menores/bastos/rey.jpg": 37417,
	"./cards/menores/bastos/seis.jpg": 50591,
	"./cards/menores/bastos/siete.jpg": 70411,
	"./cards/menores/bastos/sota.jpg": 13173,
	"./cards/menores/bastos/tres.jpg": 80507,
	"./cards/menores/copas/as.jpg": 66662,
	"./cards/menores/copas/caballo.jpg": 89035,
	"./cards/menores/copas/cinco.jpg": 50594,
	"./cards/menores/copas/cuatro.jpg": 90052,
	"./cards/menores/copas/diez.jpg": 23379,
	"./cards/menores/copas/dos.jpg": 14987,
	"./cards/menores/copas/nueve.jpg": 43218,
	"./cards/menores/copas/ocho.jpg": 59012,
	"./cards/menores/copas/reina.jpg": 43595,
	"./cards/menores/copas/rey.jpg": 56246,
	"./cards/menores/copas/seis.jpg": 58256,
	"./cards/menores/copas/siete.jpg": 66327,
	"./cards/menores/copas/sota.jpg": 1032,
	"./cards/menores/copas/tres.jpg": 4290,
	"./cards/menores/espadas/as.jpg": 71632,
	"./cards/menores/espadas/caballo.jpg": 67984,
	"./cards/menores/espadas/cinco.jpg": 3791,
	"./cards/menores/espadas/cuatro.jpg": 63177,
	"./cards/menores/espadas/diez.jpg": 29835,
	"./cards/menores/espadas/dos.jpg": 3713,
	"./cards/menores/espadas/nueve.jpg": 1980,
	"./cards/menores/espadas/ocho.jpg": 75761,
	"./cards/menores/espadas/reina.jpg": 42112,
	"./cards/menores/espadas/rey.jpg": 44755,
	"./cards/menores/espadas/seis.jpg": 99868,
	"./cards/menores/espadas/siete.jpg": 78226,
	"./cards/menores/espadas/sota.jpg": 88363,
	"./cards/menores/espadas/tres.jpg": 44148,
	"./cards/menores/oros/as.jpg": 92575,
	"./cards/menores/oros/caballo.jpg": 29869,
	"./cards/menores/oros/cinco.jpg": 20743,
	"./cards/menores/oros/cuatro.jpg": 9158,
	"./cards/menores/oros/diez.jpg": 60103,
	"./cards/menores/oros/dos.jpg": 43058,
	"./cards/menores/oros/nueve.jpg": 63473,
	"./cards/menores/oros/ocho.jpg": 78399,
	"./cards/menores/oros/reina.jpg": 15556,
	"./cards/menores/oros/rey.jpg": 47541,
	"./cards/menores/oros/seis.jpg": 47275,
	"./cards/menores/oros/siete.jpg": 42910,
	"./cards/menores/oros/sota.jpg": 51206,
	"./cards/menores/oros/tres.jpg": 52194,
	"./corte/mayores/el-carro.jpg": 32223,
	"./corte/mayores/el-colgado.jpg": 30681,
	"./corte/mayores/el-diablo.jpg": 29112,
	"./corte/mayores/el-emperador.jpg": 55218,
	"./corte/mayores/el-ermitanio.jpg": 21103,
	"./corte/mayores/el-juicio.jpg": 78023,
	"./corte/mayores/el-loco.jpg": 33339,
	"./corte/mayores/el-mago.jpg": 58891,
	"./corte/mayores/el-mundo.jpg": 93708,
	"./corte/mayores/el-papa.jpg": 13138,
	"./corte/mayores/el-sol.jpg": 50293,
	"./corte/mayores/la-emperatriz.jpg": 1319,
	"./corte/mayores/la-estrella.jpg": 63526,
	"./corte/mayores/la-fuerza.jpg": 86203,
	"./corte/mayores/la-justicia.jpg": 61459,
	"./corte/mayores/la-luna.jpg": 3705,
	"./corte/mayores/la-muerte.jpg": 45318,
	"./corte/mayores/la-rueda-de-la-fortuna.jpg": 15409,
	"./corte/mayores/la-sacerdotisa.jpg": 65209,
	"./corte/mayores/la-templanza.jpg": 18095,
	"./corte/mayores/la-torre.jpg": 53762,
	"./corte/mayores/los-enamorados.jpg": 11676,
	"./corte/menores/bastos/as.jpg": 82862,
	"./corte/menores/bastos/caballo.jpg": 70529,
	"./corte/menores/bastos/cinco.jpg": 26253,
	"./corte/menores/bastos/cuatro.jpg": 12695,
	"./corte/menores/bastos/diez.jpg": 13376,
	"./corte/menores/bastos/dos.jpg": 40716,
	"./corte/menores/bastos/nueve.jpg": 18789,
	"./corte/menores/bastos/ocho.jpg": 55117,
	"./corte/menores/bastos/reina.jpg": 301,
	"./corte/menores/bastos/rey.jpg": 14539,
	"./corte/menores/bastos/seis.jpg": 60553,
	"./corte/menores/bastos/siete.jpg": 72827,
	"./corte/menores/bastos/sota.jpg": 49559,
	"./corte/menores/bastos/tres.jpg": 6999,
	"./corte/menores/copas/as.jpg": 85546,
	"./corte/menores/copas/caballo.jpg": 34380,
	"./corte/menores/copas/cinco.jpg": 84994,
	"./corte/menores/copas/cuatro.jpg": 644,
	"./corte/menores/copas/diez.jpg": 3553,
	"./corte/menores/copas/dos.jpg": 78198,
	"./corte/menores/copas/nueve.jpg": 77865,
	"./corte/menores/copas/ocho.jpg": 77328,
	"./corte/menores/copas/reina.jpg": 26773,
	"./corte/menores/copas/rey.jpg": 78935,
	"./corte/menores/copas/seis.jpg": 61083,
	"./corte/menores/copas/siete.jpg": 67719,
	"./corte/menores/copas/sota.jpg": 3768,
	"./corte/menores/copas/tres.jpg": 44576,
	"./corte/menores/espadas/as.jpg": 94290,
	"./corte/menores/espadas/caballo.jpg": 46064,
	"./corte/menores/espadas/cinco.jpg": 78263,
	"./corte/menores/espadas/cuatro.jpg": 50128,
	"./corte/menores/espadas/diez.jpg": 22471,
	"./corte/menores/espadas/dos.jpg": 37754,
	"./corte/menores/espadas/nueve.jpg": 96145,
	"./corte/menores/espadas/ocho.jpg": 31601,
	"./corte/menores/espadas/reina.jpg": 40363,
	"./corte/menores/espadas/rey.jpg": 56776,
	"./corte/menores/espadas/seis.jpg": 64703,
	"./corte/menores/espadas/siete.jpg": 36712,
	"./corte/menores/espadas/sota.jpg": 79523,
	"./corte/menores/espadas/tres.jpg": 63824,
	"./corte/menores/oros/as.jpg": 28015,
	"./corte/menores/oros/caballo.jpg": 7622,
	"./corte/menores/oros/cinco.jpg": 11626,
	"./corte/menores/oros/cuatro.jpg": 91783,
	"./corte/menores/oros/diez.jpg": 80058,
	"./corte/menores/oros/dos.jpg": 93446,
	"./corte/menores/oros/nueve.jpg": 68596,
	"./corte/menores/oros/ocho.jpg": 25721,
	"./corte/menores/oros/reina.jpg": 37495,
	"./corte/menores/oros/rey.jpg": 27951,
	"./corte/menores/oros/seis.jpg": 80673,
	"./corte/menores/oros/siete.jpg": 27917,
	"./corte/menores/oros/sota.jpg": 1260,
	"./corte/menores/oros/tres.jpg": 83326,
	"./dark/mayores/el-carro.jpg": 96887,
	"./dark/mayores/el-colgado.jpg": 18879,
	"./dark/mayores/el-diablo.jpg": 63225,
	"./dark/mayores/el-emperador.jpg": 44637,
	"./dark/mayores/el-ermitanio.jpg": 58445,
	"./dark/mayores/el-juicio.jpg": 27985,
	"./dark/mayores/el-loco.jpg": 63430,
	"./dark/mayores/el-mago.jpg": 79363,
	"./dark/mayores/el-mundo.jpg": 40809,
	"./dark/mayores/el-papa.jpg": 97551,
	"./dark/mayores/el-sol.jpg": 93545,
	"./dark/mayores/la-emperatriz.jpg": 24293,
	"./dark/mayores/la-estrella.jpg": 80271,
	"./dark/mayores/la-fuerza.jpg": 66049,
	"./dark/mayores/la-justicia.jpg": 14936,
	"./dark/mayores/la-luna.jpg": 5759,
	"./dark/mayores/la-muerte.jpg": 30939,
	"./dark/mayores/la-rueda-de-la-fortuna.jpg": 30578,
	"./dark/mayores/la-sacerdotisa.jpg": 4662,
	"./dark/mayores/la-templanza.jpg": 32048,
	"./dark/mayores/la-torre.jpg": 56951,
	"./dark/mayores/los-enamorados.jpg": 95127,
	"./dark/menores/bastos/as.jpg": 3521,
	"./dark/menores/bastos/caballo.jpg": 49693,
	"./dark/menores/bastos/cinco.jpg": 75286,
	"./dark/menores/bastos/cuatro.jpg": 45903,
	"./dark/menores/bastos/diez.jpg": 39162,
	"./dark/menores/bastos/dos.jpg": 67109,
	"./dark/menores/bastos/nueve.jpg": 42152,
	"./dark/menores/bastos/ocho.jpg": 43244,
	"./dark/menores/bastos/reina.jpg": 46033,
	"./dark/menores/bastos/rey.jpg": 5267,
	"./dark/menores/bastos/seis.jpg": 62530,
	"./dark/menores/bastos/siete.jpg": 24352,
	"./dark/menores/bastos/sota.jpg": 62220,
	"./dark/menores/bastos/tres.jpg": 75079,
	"./dark/menores/copas/as.jpg": 85509,
	"./dark/menores/copas/caballo.jpg": 13067,
	"./dark/menores/copas/cinco.jpg": 95568,
	"./dark/menores/copas/cuatro.jpg": 84808,
	"./dark/menores/copas/diez.jpg": 5341,
	"./dark/menores/copas/dos.jpg": 29269,
	"./dark/menores/copas/nueve.jpg": 20517,
	"./dark/menores/copas/ocho.jpg": 40205,
	"./dark/menores/copas/reina.jpg": 45034,
	"./dark/menores/copas/rey.jpg": 38198,
	"./dark/menores/copas/seis.jpg": 19605,
	"./dark/menores/copas/siete.jpg": 51947,
	"./dark/menores/copas/sota.jpg": 91225,
	"./dark/menores/copas/tres.jpg": 4867,
	"./dark/menores/espadas/as.jpg": 10356,
	"./dark/menores/espadas/caballo.jpg": 76492,
	"./dark/menores/espadas/cinco.jpg": 69491,
	"./dark/menores/espadas/cuatro.jpg": 50391,
	"./dark/menores/espadas/diez.jpg": 44968,
	"./dark/menores/espadas/dos.jpg": 85321,
	"./dark/menores/espadas/nueve.jpg": 62839,
	"./dark/menores/espadas/ocho.jpg": 24056,
	"./dark/menores/espadas/reina.jpg": 690,
	"./dark/menores/espadas/rey.jpg": 66341,
	"./dark/menores/espadas/seis.jpg": 59399,
	"./dark/menores/espadas/siete.jpg": 47318,
	"./dark/menores/espadas/sota.jpg": 45107,
	"./dark/menores/espadas/tres.jpg": 26153,
	"./dark/menores/oros/as.jpg": 39761,
	"./dark/menores/oros/caballo.jpg": 83667,
	"./dark/menores/oros/cinco.jpg": 12,
	"./dark/menores/oros/cuatro.jpg": 45727,
	"./dark/menores/oros/diez.jpg": 93722,
	"./dark/menores/oros/dos.jpg": 65098,
	"./dark/menores/oros/nueve.jpg": 23812,
	"./dark/menores/oros/ocho.jpg": 69331,
	"./dark/menores/oros/reina.jpg": 31438,
	"./dark/menores/oros/rey.jpg": 48613,
	"./dark/menores/oros/seis.jpg": 40618,
	"./dark/menores/oros/siete.jpg": 40852,
	"./dark/menores/oros/sota.jpg": 78143,
	"./dark/menores/oros/tres.jpg": 82268,
	"./images/1.jpg": 97097,
	"./images/about/el-mago-1.jpg": 59126,
	"./images/about/el-mago-10.jpg": 46940,
	"./images/about/el-mago-11.jpg": 15497,
	"./images/about/el-mago-12.jpg": 65915,
	"./images/about/el-mago-13.jpg": 75420,
	"./images/about/el-mago-14.jpg": 41747,
	"./images/about/el-mago-15.jpg": 85627,
	"./images/about/el-mago-16.jpg": 37283,
	"./images/about/el-mago-17.jpg": 32227,
	"./images/about/el-mago-18.jpg": 684,
	"./images/about/el-mago-2.jpg": 27015,
	"./images/about/el-mago-3.jpg": 18043,
	"./images/about/el-mago-4.jpg": 60603,
	"./images/about/el-mago-5.jpg": 13629,
	"./images/about/el-mago-6.jpg": 1681,
	"./images/about/el-mago-7.jpg": 75565,
	"./images/about/el-mago-8.jpg": 86987,
	"./images/about/el-mago-9.jpg": 57279,
	"./images/about/el-mago.jpg": 11151,
	"./images/abundancia/fondo.jpg": 47747,
	"./images/amor/fondo.jpg": 6285,
	"./images/amor/light.jpg": 38653,
	"./images/arrow_left.png": 38458,
	"./images/atraccion/fondo.jpg": 98083,
	"./images/autoconocimiento/fondo.jpg": 55232,
	"./images/bloqueo/fondo.jpg": 55558,
	"./images/calcular.png": 19760,
	"./images/celta/fondo.jpg": 73792,
	"./images/compatibilidad/fondo.jpg": 62933,
	"./images/encrucijada/fondo.jpg": 5096,
	"./images/evolutivo/fondo.jpg": 16856,
	"./images/ex-pareja/fondo.jpg": 22929,
	"./images/footer/facebook.svg": 68679,
	"./images/footer/instagram.svg": 88083,
	"./images/footer/pagos.png": 65734,
	"./images/footer/pagos.webp": 71676,
	"./images/footer/whatsapp.svg": 98012,
	"./images/free.jpeg": 29158,
	"./images/futuro/fondo.jpg": 38222,
	"./images/futuro2/fondo.jpg": 44023,
	"./images/general/acuario.png": 55259,
	"./images/general/aries.png": 96271,
	"./images/general/cancer.png": 70202,
	"./images/general/capricornio.png": 10041,
	"./images/general/escorpio.png": 50246,
	"./images/general/fondo.jpg": 61759,
	"./images/general/geminis.png": 58570,
	"./images/general/leo.png": 82595,
	"./images/general/libra.png": 17021,
	"./images/general/piscis.png": 21695,
	"./images/general/sagitario.png": 22888,
	"./images/general/tauro.png": 37531,
	"./images/general/virgo.png": 9034,
	"./images/homepage/background.jpg": 26275,
	"./images/homepage/background.png": 97743,
	"./images/homepage/child-1835730_1280.jpg": 56286,
	"./images/homepage/fondo.jpg": 87546,
	"./images/homepage/inversiones.jpg": 90255,
	"./images/homepage/justicia.jpg": 88578,
	"./images/homepage/moneyu.jpg": 77873,
	"./images/homepage/moving.jpg": 41960,
	"./images/homepage/smiling-woman-1340662_1280.jpg": 2646,
	"./images/homepage/viajes.jpg": 95918,
	"./images/homepage/woman-gd817d42f0_1280.jpg": 83424,
	"./images/iching/1.png": 50308,
	"./images/iching/10.png": 44803,
	"./images/iching/11.png": 45394,
	"./images/iching/12.png": 16774,
	"./images/iching/13.png": 26514,
	"./images/iching/14.png": 29854,
	"./images/iching/15.png": 18310,
	"./images/iching/16.png": 23728,
	"./images/iching/17.png": 57524,
	"./images/iching/18.png": 21070,
	"./images/iching/19.png": 91084,
	"./images/iching/2.png": 93510,
	"./images/iching/20.png": 80522,
	"./images/iching/21.png": 22166,
	"./images/iching/22.png": 21073,
	"./images/iching/23.png": 7908,
	"./images/iching/24.png": 94289,
	"./images/iching/25.png": 17947,
	"./images/iching/26.png": 54199,
	"./images/iching/27.png": 48190,
	"./images/iching/28.png": 28509,
	"./images/iching/29.png": 9062,
	"./images/iching/3.png": 7093,
	"./images/iching/30.png": 89797,
	"./images/iching/31.png": 29288,
	"./images/iching/32.png": 97794,
	"./images/iching/33.png": 60102,
	"./images/iching/34.png": 11320,
	"./images/iching/35.png": 26404,
	"./images/iching/36.png": 58536,
	"./images/iching/37.png": 62138,
	"./images/iching/38.png": 13123,
	"./images/iching/39.png": 83104,
	"./images/iching/4.png": 49972,
	"./images/iching/40.png": 20339,
	"./images/iching/41.png": 12928,
	"./images/iching/42.png": 54234,
	"./images/iching/43.png": 89914,
	"./images/iching/44.png": 33517,
	"./images/iching/45.png": 74512,
	"./images/iching/46.png": 68207,
	"./images/iching/47.png": 2150,
	"./images/iching/48.png": 59488,
	"./images/iching/49.png": 91232,
	"./images/iching/5.png": 51274,
	"./images/iching/50.png": 47219,
	"./images/iching/51.png": 61410,
	"./images/iching/52.png": 56579,
	"./images/iching/53.png": 15008,
	"./images/iching/54.png": 8313,
	"./images/iching/55.png": 25472,
	"./images/iching/56.png": 1111,
	"./images/iching/57.png": 75939,
	"./images/iching/58.png": 14038,
	"./images/iching/59.png": 4741,
	"./images/iching/6.png": 88610,
	"./images/iching/60.png": 58553,
	"./images/iching/61.png": 3333,
	"./images/iching/62.png": 52027,
	"./images/iching/63.png": 48443,
	"./images/iching/64.png": 11589,
	"./images/iching/7.png": 35222,
	"./images/iching/8.png": 73514,
	"./images/iching/9.png": 53937,
	"./images/iching/fondo.jpg": 22227,
	"./images/iching/yan.png": 15156,
	"./images/iching/yin.png": 56842,
	"./images/infidelidad/fondo.jpg": 96325,
	"./images/interior/fondo.jpg": 4782,
	"./images/invert.svg": 50859,
	"./images/login/Screen Recording 2023-04-20 at 17.13.59.mov": 81380,
	"./images/login/noshow.svg": 50040,
	"./images/login/show.svg": 14554,
	"./images/mejor/fondo.jpg": 31268,
	"./images/mejor10/fondo.jpg": 79495,
	"./images/mejor10/new_user.png": 21300,
	"./images/mejor10/user.png": 29522,
	"./images/mejor10/users.png": 19877,
	"./images/natal/fondo.jpg": 94514,
	"./images/navbar/astral.png": 80011,
	"./images/navbar/estelar.ico": 28691,
	"./images/navbar/estelar.png": 55283,
	"./images/navbar/sun.png": 41660,
	"./images/navbar/tarot.png": 25728,
	"./images/personality/abuela.jpg": 6597,
	"./images/personality/agrandada.jpg": 11716,
	"./images/personality/astrologa-bohemia.jpg": 49416,
	"./images/personality/austral.jpg": 96272,
	"./images/personality/barrio.jpg": 19400,
	"./images/personality/campera.jpg": 32022,
	"./images/personality/cariñosa.jpg": 84597,
	"./images/personality/cariñosalatina.jpg": 94555,
	"./images/personality/cheta.jpg": 59134,
	"./images/personality/chismosa.jpg": 40264,
	"./images/personality/citadina.jpg": 16131,
	"./images/personality/comerciante.jpg": 99186,
	"./images/personality/conurbano.jpg": 29559,
	"./images/personality/cordobesa.jpg": 81562,
	"./images/personality/gaucha.jpg": 3031,
	"./images/personality/hippie.jpg": 77419,
	"./images/personality/jubilada.jpg": 57450,
	"./images/personality/maestra.jpg": 68364,
	"./images/personality/marcelo.jpg": 24148,
	"./images/personality/mistica.jpg": 25630,
	"./images/personality/pedante.jpg": 75889,
	"./images/personality/porteña.jpg": 92683,
	"./images/personality/pueblerina.jpg": 77340,
	"./images/personality/puneña.jpg": 7435,
	"./images/preguntas/fondo.jpg": 8087,
	"./images/propio/fondo.jpg": 43453,
	"./images/proteccion/fondo.jpg": 85813,
	"./images/renacer/fondo.jpg": 18884,
	"./images/sino/fondo.jpg": 40103,
	"./images/tapiz.jpg": 17726,
	"./images/tapiz1.jpg": 91708,
	"./images/tapiz12.jpg": 77672,
	"./images/tapiz2.jpg": 97819,
	"./images/tapiz3.jpg": 62892,
	"./images/tapiz4.jpg": 31092,
	"./images/tapiz4.png": 18810,
	"./images/tapiz5.jpg": 36666,
	"./images/temporada/fondo.jpg": 21022,
	"./images/trabajo/fondo.jpg": 92304,
	"./images/vidapasada/fondo.jpg": 78127,
	"./images/view.png": 14343,
	"./marsella/mayores/el-carro.jpg": 16410,
	"./marsella/mayores/el-colgado.jpg": 60211,
	"./marsella/mayores/el-diablo.jpg": 5616,
	"./marsella/mayores/el-emperador.jpg": 18234,
	"./marsella/mayores/el-ermitanio.jpg": 38432,
	"./marsella/mayores/el-juicio.jpg": 95026,
	"./marsella/mayores/el-loco.jpg": 36806,
	"./marsella/mayores/el-mago.jpg": 12960,
	"./marsella/mayores/el-mundo.jpg": 27014,
	"./marsella/mayores/el-papa.jpg": 62178,
	"./marsella/mayores/el-sol.jpg": 87556,
	"./marsella/mayores/la-emperatriz.jpg": 46415,
	"./marsella/mayores/la-estrella.jpg": 71075,
	"./marsella/mayores/la-fuerza.jpg": 27774,
	"./marsella/mayores/la-justicia.jpg": 575,
	"./marsella/mayores/la-luna.jpg": 91209,
	"./marsella/mayores/la-muerte.jpg": 70759,
	"./marsella/mayores/la-rueda-de-la-fortuna.jpg": 79169,
	"./marsella/mayores/la-sacerdotisa.jpg": 61662,
	"./marsella/mayores/la-templanza.jpg": 63923,
	"./marsella/mayores/la-torre.jpg": 24891,
	"./marsella/mayores/los-enamorados.jpg": 13306,
	"./marsella/menores/bastos/as.jpg": 16556,
	"./marsella/menores/bastos/caballo.jpg": 25114,
	"./marsella/menores/bastos/cinco.jpg": 38964,
	"./marsella/menores/bastos/cuatro.jpg": 87337,
	"./marsella/menores/bastos/diez.jpg": 71100,
	"./marsella/menores/bastos/dos.jpg": 25921,
	"./marsella/menores/bastos/nueve.jpg": 27806,
	"./marsella/menores/bastos/ocho.jpg": 54875,
	"./marsella/menores/bastos/reina.jpg": 6906,
	"./marsella/menores/bastos/rey.jpg": 29875,
	"./marsella/menores/bastos/seis.jpg": 91224,
	"./marsella/menores/bastos/siete.jpg": 35233,
	"./marsella/menores/bastos/sota.jpg": 22810,
	"./marsella/menores/bastos/tres.jpg": 84535,
	"./marsella/menores/copas/as.jpg": 15290,
	"./marsella/menores/copas/caballo.jpg": 407,
	"./marsella/menores/copas/cinco.jpg": 64972,
	"./marsella/menores/copas/cuatro.jpg": 90625,
	"./marsella/menores/copas/diez.jpg": 3059,
	"./marsella/menores/copas/dos.jpg": 32833,
	"./marsella/menores/copas/nueve.jpg": 23092,
	"./marsella/menores/copas/ocho.jpg": 95802,
	"./marsella/menores/copas/reina.jpg": 41362,
	"./marsella/menores/copas/rey.jpg": 44167,
	"./marsella/menores/copas/seis.jpg": 52389,
	"./marsella/menores/copas/siete.jpg": 19675,
	"./marsella/menores/copas/sota.jpg": 53595,
	"./marsella/menores/copas/tres.jpg": 38493,
	"./marsella/menores/espadas/as.jpg": 37434,
	"./marsella/menores/espadas/caballo.jpg": 6846,
	"./marsella/menores/espadas/cinco.jpg": 55612,
	"./marsella/menores/espadas/cuatro.jpg": 56224,
	"./marsella/menores/espadas/diez.jpg": 82515,
	"./marsella/menores/espadas/dos.jpg": 88577,
	"./marsella/menores/espadas/nueve.jpg": 86442,
	"./marsella/menores/espadas/ocho.jpg": 59211,
	"./marsella/menores/espadas/reina.jpg": 53407,
	"./marsella/menores/espadas/rey.jpg": 6294,
	"./marsella/menores/espadas/seis.jpg": 26650,
	"./marsella/menores/espadas/siete.jpg": 63904,
	"./marsella/menores/espadas/sota.jpg": 84471,
	"./marsella/menores/espadas/tres.jpg": 87553,
	"./marsella/menores/oros/as.jpg": 93948,
	"./marsella/menores/oros/caballo.jpg": 45180,
	"./marsella/menores/oros/cinco.jpg": 18487,
	"./marsella/menores/oros/cuatro.jpg": 16288,
	"./marsella/menores/oros/diez.jpg": 17145,
	"./marsella/menores/oros/dos.jpg": 11424,
	"./marsella/menores/oros/nueve.jpg": 42568,
	"./marsella/menores/oros/ocho.jpg": 50295,
	"./marsella/menores/oros/reina.jpg": 24173,
	"./marsella/menores/oros/rey.jpg": 11553,
	"./marsella/menores/oros/seis.jpg": 63419,
	"./marsella/menores/oros/siete.jpg": 7372,
	"./marsella/menores/oros/sota.jpg": 57928,
	"./marsella/menores/oros/tres.jpg": 34327,
	"./vids/eight.mp4": 2505,
	"./vids/five.mp4": 54503,
	"./vids/four.mp4": 55903,
	"./vids/nine.mp4": 91586,
	"./vids/one.mp4": 84430,
	"./vids/seven.mp4": 34994,
	"./vids/six.mp4": 71637,
	"./vids/ten.mp4": 26737,
	"./vids/three.mp4": 86331,
	"./vids/two.mp4": 67747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;